import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IAdjustmentTablesSearchParam,
  IIncrementalOptionTableReport,
} from "../../../Interfaces/deltaHedgeAdjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import { getCustomIncrementalOptionTable } from "../../../Requests/deltaHedgeAdjustment";

interface IProps {
  searchParams: IAdjustmentTablesSearchParam;
}

const IncrementalOptionTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAdjustmentTablesSearchParam, IIncrementalOptionTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[400px] !max-w-full overflow-x-auto"
        />
      )}
      getDataTable={getCustomIncrementalOptionTable}
      searchParameters={searchParams}
      withSort
      refreshTableTime={5000}
    />
  );
};

export default IncrementalOptionTable;
